export default __webpack_public_path__ + "static/media/doctor1.4670d259.png";